import { isEmbarcacaoBaseTecnicaEmpty } from "@/modules/embarcacoes/embarcacoes.types";
import type {
  EmbarcacaoBaseTecnica,
  EmbarcacaoBaseTecnicaState,
} from "@/modules/embarcacoes/embarcacoes.types";
import { useEmbarcacaoDetailSection } from "./use-embarcacao-detail-section";
import type { EmbarcacaoDetailSectionQuery } from "./use-embarcacao-detail-section";

const BASE_TECNICA_QUERY: EmbarcacaoDetailSectionQuery<EmbarcacaoBaseTecnica> = {
  select: (ficha) => ficha.baseTecnica,
  isEmpty: isEmbarcacaoBaseTecnicaEmpty,
  secao: "a Base Técnica",
};

interface UseEmbarcacaoBaseTecnicaResult extends EmbarcacaoBaseTecnicaState {
  reload: () => void;
}

export function useEmbarcacaoBaseTecnica(id: string): UseEmbarcacaoBaseTecnicaResult {
  const { data, ...state } = useEmbarcacaoDetailSection(id, BASE_TECNICA_QUERY);

  return { ...state, baseTecnica: data };
}
